import { render, staticRenderFns } from "./AddInside.vue?vue&type=template&id=20fa903d&scoped=true&"
import script from "./AddInside.vue?vue&type=script&lang=js&"
export * from "./AddInside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fa903d",
  null
  
)

export default component.exports